export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  className = "",
}) {
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}
    >
      {eyebrow && <div className="overline">{eyebrow}</div>}
      <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-display font-light tracking-tight text-balance">
        {title}
      </h2>
      {description && (
        <p className="mt-6 text-base md:text-lg text-zinc-400 leading-relaxed text-pretty">
          {description}
        </p>
      )}
    </div>
  );
}
